import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface UploadAvatarInputProps {
  readOnly: boolean;
  setAvatar: (file: File) => void;
  handleUploadAvatar: () => void;
  loading: boolean;
  buttonLabel: string;
}

export const UploadAvatarInput = ({
  readOnly,
  setAvatar,
  handleUploadAvatar,
  buttonLabel,
  loading
}: UploadAvatarInputProps) => {
  return (
    <div className="flex items-center gap-2">
      <Input
        disabled={readOnly}
        loading={loading}
        type="file"
        accept="image/*"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            setAvatar(file);
          }
        }}
      />
      <Button onClick={() => handleUploadAvatar()} variant="outline" size="sm">
        {buttonLabel}
      </Button>
    </div>
  );
};
